import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { EstacaoService } from 'src/services/estacao.service';
import { MonitoramentoService } from 'src/services/monitoramento.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { LogEmailMonitoramentoService } from 'src/services/log-email-monitoramento.service';
import { GrupoEmailService } from 'src/services/grupo-email.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { EventosMonitoramentosDialogComponent } from 'src/app/shared/eventos-monitoramentos-dialog/eventos-monitoramentos-dialog.component';

@Component({
    selector: 'app-monitoramento',
    templateUrl: './monitoramento.component.html',
    styleUrls: ['./monitoramento.component.scss'],
    standalone: false
})
export class MonitoramentoComponent implements OnInit{
  modal: boolean = false
  load: boolean = false
  loadModal: boolean = false
  loadingEnviarEmail: boolean = false
  modalNovoGrupo: boolean = false
  estacao_ids: any[] = []
  data: any[] = []
  dataModal: any[] = []
  rangeDate: any[] = []
  readonly SITUACAO_TODOS = 'todos';
  situacao: any = 'null';
  estacaoModal: any
  monitoramentoIdModal: number | null = null
  dropDownEstacao: any[] = [];
  dropDownSituacao: any[] = [
    {value: 'null', label: 'Selecione'},
    {value: this.SITUACAO_TODOS, label: 'Todos Monitoramentos'},
    {value: 0, label: 'Em Monitoramento'},
    {value: 1, label: 'Fechado'},
  ];
  grupo_email_id: any = 'null';
  dropDownGrupoEmail: any[] = [];
  exibirFiltroAvancado: boolean = false
  dropDownGrupos: any[] = [];
  dropDownSensores: any[] = [];
  dropDownClientes: any[] = [];
  clientesFiltrados: any[] = [];
  grupo: any
  sensor: any
  cliente: any

  plu_filtro: any
  flu_filtro: any
  integrador_filtro: any[] = []
  coletor_filtro: any[] = []
  dropDownIntegradores: any[] = []
  dropDownColetores: any[] = []

  @ViewChild('eventosMonitoramentosDialog')
  eventosMonitoramentosDialog!: EventosMonitoramentosDialogComponent;

  constructor(
    protected _estacaoService: EstacaoService,
    protected _monitoramentoService: MonitoramentoService,
    protected _pessoaService: PessoaService,
    protected _sensorService: SensorService,
    protected _estacaoGrupoService: EstacaoGrupoService,
    protected permissaoService: PermissoesService,
    protected _logEmailMonitoramentoService: LogEmailMonitoramentoService,
    protected _grupoEmailService: GrupoEmailService,
    protected messageService: MessageService,
    protected confirmationService: ConfirmationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Verifica se o usuário tem permissão para acessar esta página
    if (!this.permissaoService.can('monitoramento_visualizar')) {
      this.router.navigate(['/notfound']);
      return;
    }

    this.listEstacoes()
    this.listGruposEmail()
    this.listGrupos()
    this.listSensores()
    this.listClientes()
  }

listGruposEmail() {
  this.dropDownGrupoEmail = [
    { label: 'Selecione', value: 'null' }
  ];

  this._grupoEmailService.index().subscribe((json: any) => {
    json.map((item: any) => {
      this.dropDownGrupoEmail.push({
        label: item.descricao,
        value: item.id
      });
    });
  });
}

toggleFiltroAvancado(): void {
this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
}

listClientes(){
  this.dropDownClientes = []
  this._pessoaService.index().subscribe(json => {
    let ret = json.filter(x => x.ativo == true)
    ret.map(item => {
      this.dropDownClientes.push({
        label: item.nome, value: item.id
      })
      
    })
  })
}

listGrupos(){
this.dropDownGrupos = []
this._estacaoGrupoService.index().subscribe(json => {
  json.map(item => {
    this.dropDownGrupos.push({
      label: item.nome, value: item.id
    })
    
  })
})
}

filtrarClientes(event) {
let query = event.query;
this._pessoaService.autocomplete(query).subscribe((json) => {
    let clientes = [];
    json.map((item) => {
        clientes.push({
            value: item.value,
            label: item.label,
        });
        this.clientesFiltrados = clientes;
    });
});
}

listSensores(){
this.dropDownSensores = []
this._sensorService.index().subscribe(json => {
json.map(item => {
  
    this.dropDownSensores.push({
      value: item.id, label: item.descricao,
    })

 
})
})
}


  listEstacoes(){
    this.dropDownEstacao = []
    this._estacaoService.lookup().subscribe(json => {
      (json || []).forEach(item => {
        this.dropDownEstacao.push({
          label: item.descricao, value: item.id
        })
      })
    })
  }

  private obterIdsEstacaoSelecionadas(): number[] {
    return (this.estacao_ids || [])
      .map(item => item && typeof item === 'object' ? item.value : item)
      .filter(id => id != null && id !== 'null');
  }

  podeEnviarEmailEstacao(): boolean {
    return this.obterIdsEstacaoSelecionadas().length === 1;
  }

  isTodosMonitoramentos(): boolean {
    return this.situacao === this.SITUACAO_TODOS;
  }

  onSituacaoChange(): void {
    if (this.isTodosMonitoramentos()) {
      this.rangeDate = [];
    }
  }

  podeFiltrar(): boolean {
    return this.isTodosMonitoramentos()
      || (!!this.rangeDate && this.rangeDate.length >= 2 && !!this.rangeDate[0] && !!this.rangeDate[1]);
  }

  filtrar(){
    const todosMonitoramentos = this.isTodosMonitoramentos();

    if (!todosMonitoramentos && !this.podeFiltrar()) {
      return;
    }

    this.load = true
    this.data = []
    let data: any[] = []

    let grupos: any = []
    let clientes: any = []
    let sensores: any = []

    if(this.grupo){
      this.grupo.map(item => {
        grupos.push(item.value)
      })
    }
    if(this.cliente){
      this.cliente.map(item => {
        clientes.push(item.value)
      })
    }
    if(this.sensor){
      this.sensor.map(item => {
        sensores.push(item.value)
      })
    }

    let integradores: any[] = []
    let coletores: any[] = []

    if(integradores){
      this.integrador_filtro.map(item => {
        integradores.push(item.id)
      })
    }

    if(coletores){
      this.coletor_filtro.map(item => {
        coletores.push(item.id)
      })
    }

    const estacoes = this.obterIdsEstacaoSelecionadas();
   
    const inicio = todosMonitoramentos ? null : moment(this.rangeDate[0]).format('YYYY-MM-DD');
    const fim = todosMonitoramentos ? null : moment(this.rangeDate[1]).format('YYYY-MM-DD');
    const situacao = todosMonitoramentos ? null : this.situacao;

    this._monitoramentoService.listMonitoramentos(estacoes, inicio, fim, situacao, grupos, clientes, sensores, this.plu_filtro, this.flu_filtro, integradores, coletores).subscribe((json: any) => {
      json.map(item => {
        if(item.data_hora_ultima_situacao !== null){
          item.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('DD/MM/YYYY HH:mm')
        } 
        if(item.status == 0){
          item.status = 'Em Monitoramento'
        } else {
          item.status = 'Fechado'
        }
        data.push({
          id: item.id,
          estacao: item.estacao?.descricao,
          estacao_id: item.estacao?.id,
          tipo_evento: item.tipo_evento?.descricao,
          situacao: item.status,
          inicio: moment(item.data_hora_monitoramento).format('DD/MM/YYYY HH:mm'),
          fim: item.data_hora_ultima_situacao,
          log_email_monitoramento: item.log_email_monitoramento
        })
      })
      this.data = data
      this.load = false
      
    }, err => {
      this.load = false
    })
  }

  // filtrar(){
  //   this.load = true
  //   this.data = []
  //   let data: any[] = []
  //   if(this.situacao == 'null'){
  //     forkJoin([
  //       this._monitoramentoService.listMonitoramentos(this.estacao_id, moment(this.rangeDate[0]).format('YYYY-MM-DD'),null, 0),
  //       this._monitoramentoService.listMonitoramentos(this.estacao_id, moment(this.rangeDate[0]).format('YYYY-MM-DD'),moment(this.rangeDate[1]).format('YYYY-MM-DD'), 2)
  //     ]).subscribe(json => {
  //       json.map((item: any) => {
  //         if(item.data_hora_ultima_situacao !== null){
  //           item.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('DD/MM/YYYY HH:mm')
  //         } 
  //         if(item.status == 0){
  //           item.status = 'Em Monitoramento'
  //         } else {
  //           item.status = 'Fechado'
  //         }
  //         data.push({
  //           id: item.id,
  //           estacao: item.estacao?.descricao,
  //           tipo_evento: item.tipo_evento?.descricao,
  //           situacao: item.status,
  //           inicio: moment(item.data_hora_monitoramento).format('DD/MM/YYYY HH:mm'),
  //           fim: item.data_hora_ultima_situacao,
  //           log_email_monitoramento: item.log_email_monitoramento
  //         })
  //       })
  //       this.data = data
  //       this.load = false
  //     }, err => {
  //       this.load = false
  //     })
     
      
  //   }
    
  //   else {
  //     this._monitoramentoService.listMonitoramentos(this.estacao_id, moment(this.rangeDate[0]).format('YYYY-MM-DD'), moment(this.rangeDate[1]).format('YYYY-MM-DD'), this.situacao).subscribe((json: any) => {
  //       json.map(item => {
  //         if(item.data_hora_ultima_situacao !== null){
  //           item.data_hora_ultima_situacao = moment(item.data_hora_ultima_situacao).format('DD/MM/YYYY HH:mm')
  //         } 
  //         if(item.status == 0){
  //           item.status = 'Em Monitoramento'
  //         } else {
  //           item.status = 'Fechado'
  //         }
  //         data.push({
  //           id: item.id,
  //           estacao: item.estacao?.descricao,
  //           tipo_evento: item.tipo_evento?.descricao,
  //           situacao: item.status,
  //           inicio: moment(item.data_hora_monitoramento).format('DD/MM/YYYY HH:mm'),
  //           fim: item.data_hora_ultima_situacao,
  //           log_email_monitoramento: item.log_email_monitoramento
  //         })
  //       })
  //       this.data = data
  //       this.load = false
        
  //     }, err => {
  //       this.load = false
  //     })
  //   }
    
  // }

  index(){
   
  }

  observacao(event: any): void {
    if (!event?.id || !event?.estacao_id) {
      return;
    }

    const dataResumo = moment(event.inicio, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD');
    if (!dataResumo || dataResumo === 'Invalid date') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não foi possível identificar a data do monitoramento.'
      });
      return;
    }

    this.eventosMonitoramentosDialog.abrirPorMonitoramento({
      estacaoId: Number(event.estacao_id),
      estacaoDescricao: event.estacao || '',
      dataResumo,
      monitoramentoId: Number(event.id),
    });
  }

  envios(event: any): void {
    this.modal = true;
    this.estacaoModal = event.estacao;
    this.monitoramentoIdModal = event.id;
    this.dataModal = [];
    this.loadModal = true;

    if (!this.monitoramentoIdModal) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Monitoramento não identificado'
      });
      this.loadModal = false;
      return;
    }

    this._logEmailMonitoramentoService.listarPorMonitoramento(this.monitoramentoIdModal).subscribe({
      next: (response: any) => {
        const logs = Array.isArray(response) ? response : (response?.data && Array.isArray(response.data) ? response.data : []);
        this.dataModal = (logs || []).map((log: any) => ({
          ...log,
          emailsParsed: this.parseEmailsEnviados(log.emails_enviados || '{}')
        }));
        this.loadModal = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar logs de e-mail'
        });
        this.loadModal = false;
      }
    });
  }

  parseEmailsEnviados(emailsEnviados: string): { to: string[], cc?: string[] } {
    return this._logEmailMonitoramentoService.parseEmailsEnviados(emailsEnviados);
  }

  formatarDataHora(dataHora: string | null | undefined): string {
    if (dataHora == null || dataHora === '') return 'N/A';
    return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
  }

  enviarEmailEstacao(): void {
    const estacaoIds = this.obterIdsEstacaoSelecionadas();
    if (estacaoIds.length !== 1) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione exatamente uma estação para enviar o e-mail'
      });
      return;
    }

    const estacaoId = estacaoIds[0];
    const estacaoSelecionada = this.dropDownEstacao.find(e => e.value === estacaoId);
    const nomeEstacao = estacaoSelecionada ? estacaoSelecionada.label : `ID: ${estacaoId}`;
    const grupoEmailSelecionado = this.dropDownGrupoEmail.find(g => g.value === this.grupo_email_id);
    const nomeGrupoEmail = grupoEmailSelecionado ? grupoEmailSelecionado.label : null;

    this.confirmationService.confirm({
      key: 'globalConfirm',
      message:
        `Deseja realmente enviar e-mail de monitoramento para a estação "${nomeEstacao}"?<br>` +
        `${nomeGrupoEmail ? `O envio usará o grupo de e-mail "${nomeGrupoEmail}".` : `O e-mail será enviado para todos os grupos de e-mail relacionados a esta estação.`}`,
      header: 'Confirmar Envio de E-mail',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.loadingEnviarEmail = true;
        
        this._monitoramentoService.enviarEmailEstacao(
          estacaoId,
          this.grupo_email_id !== 'null' ? this.grupo_email_id : null
        ).subscribe({
          next: (resultado: any) => {
            this.loadingEnviarEmail = false;
            
            if (resultado.sucesso) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `${resultado.mensagem || 'E-mail enviado com sucesso'}. Grupos encontrados: ${resultado.grupos_encontrados || 0}, E-mails enviados: ${resultado.emails_enviados || 0}${resultado.emails_com_erro > 0 ? `, E-mails com erro: ${resultado.emails_com_erro}` : ''}`
              });
            } else {
              this.messageService.add({
                severity: 'info',
                summary: 'Informação',
                detail: resultado.mensagem || 'Nenhum grupo de e-mail encontrado para esta estação. Verifique o cadastro em Monitoramento > Grupos de E-mail.'
              });
            }
          },
          error: (err) => {
            this.loadingEnviarEmail = false;
            const errorMsg = err?.error?.message || 'Erro ao enviar e-mail';
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: errorMsg
            });
          }
        });
      },
      reject: () => {
        // Modal fecha automaticamente ao clicar em "Não"
      }
    });
  }

  addNovoGrupo(){
    this.modalNovoGrupo = true
   }
  
   aoSalvarNovoGrupo(): void {
    this.listGrupos()
    this.modalNovoGrupo = false;
  }

  /**
   * Abre o diálogo de confirmação para excluir o monitoramento.
   * Segue a documentação API_DELETE_E_VERIFICACAO_FRONTEND: DELETE /api/monitoramento/{id} (204 sucesso, 404 não encontrado).
   */
  confirmarExclusao(monitoramento: any): void {
    const nomeEstacao = monitoramento.estacao || `ID ${monitoramento.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o monitoramento da estação "${nomeEstacao}" (código ${monitoramento.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirMonitoramento(monitoramento.id)
    });
  }

  /**
   * Chama a API DELETE /api/monitoramento/{id}. Em sucesso (204), remove o item da lista e exibe mensagem.
   */
  private excluirMonitoramento(id: number): void {
    this._monitoramentoService.excluir(id).subscribe({
      next: () => {
        this.confirmationService.close();
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Monitoramento excluído com sucesso.'
        });
      },
      error: (err) => {
        this.confirmationService.close();
        const status = err?.status;
        const msg = err?.error?.message || err?.error?.error;
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg || 'Monitoramento não encontrado. Removido da lista.'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg || 'Não foi possível excluir o monitoramento.'
          });
        }
      }
    });
  }
}
